<template>
  <DsProcessSection
    title=""
    title-id="preventa-process-title"
    intro=""
    layout="grid"
    :columns="2"
    card-variant="compact"
    :steps="steps"
    tag=""
  >
    <template #title>¿Cómo es <span class="hl">el proceso de contratación?</span></template>
    <template #step-1
      ><p>Revisaremos tu capacidad de pago mediante:</p>
      <ul>
        <li>Comprobantes de ingresos</li>
        <li>Revisión de buró de crédito</li>
      </ul></template
    >
    <template #step-2
      ><ul>
        <li>Necesitaremos: comprobantes de pago al desarrollador</li>
        <li>transferencias y/o depósitos</li>
        <li>avalúo bancario</li>
      </ul></template
    >
    <template #step-3
      ><p>Cuando tu operación esté lista para fondeo, firmarás un contrato de mutuo.</p>
      <p>
        <strong>¿Qué es el mutuo?</strong> Es el contrato legal que formaliza tu préstamo y valida el dinero entregado
        previamente al desarrollador.
      </p></template
    >
    <template #step-4
      ><p>
        <strong>Una vez integrado tu expediente y autorizada la adjudicación:</strong> programaremos tu firma de
        escritura en un plazo aproximado de 15 días.
      </p></template
    >
  </DsProcessSection>
</template>
<script setup lang="ts">
import DsProcessSection from '../components/DsProcessSection.vue'
const steps = [
  {
    id: '1',
    title: 'Validación financiera'
  },
  {
    id: '2',
    title: 'Validación del inmueble'
  },
  {
    id: '3',
    title: 'Firma de mutuo'
  },
  {
    id: '4',
    title: 'Firma de escritura'
  }
]
</script>
